import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CheckToken } from "../../login/AccessToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ChangeCursor } from "./MiscFunctions";
import { Card, Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";

function ExchangePatientEMR() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    setError: setError1,
    getValues: getValues1,
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setError: setError2,
    getValues: getValues2,
  } = useForm();
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    setError: setError3,
    getValues: getValues3,
  } = useForm();
  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    setError: setError4,
    getValues: getValues4,
  } = useForm();
  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5 },
    setError: setError5,
    getValues: getValues5,
  } = useForm();

  const [displayAuthMode, setDisplayAuthMode] = useState(false);
  const [displayAddCareContext, setDisplayAddCareContext] = useState(false);
  const [displayOTP, setDisplayOTP] = useState(false);
  const [findPatientModes, setFindPatientModes] = useState(false);
  const [displayNotificationCareContext, setDisplayNotificationCareContext] =
    useState(false);
  const [gender, setGender] = useState(["Male", "Female", "Transgender"]);
  const [otpModes, setOtpModes] = useState([]);
  const [txnId, setTxnId] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
 const REACT_APP_SUFFIX =
  process.env.REACT_APP_IS_ABDM_CONNECTED_WITH_PROD === "true"
    ? process.env.REACT_APP_SUFFIX_PR
    : process.env.REACT_APP_SUFFIX_SB;
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const FindPatientModes = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    if (data.abha_id != "" && !data.abha_id.endsWith(REACT_APP_SUFFIX)) {
      data.abha_id += REACT_APP_SUFFIX;
    }
    if (Token()) {
      if (!data.abha_number && !data.abha_id) {
        setError("abha_number", {
          type: "manual",
          message: "You must fill out either ABHA Number or ABHA Address",
        });
        //ChangeCursor();
        return;
      }

      var post_data = {};
      post_data.query = {};

      post_data.query.id = data.abha_id;
      post_data.query.purpose = "KYC_AND_LINK";
      post_data.query.requester = {
        type: "HIP",
        id: "HLTHTEK_DEV",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}fetch_modes_workflow/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status !== "Failed") {
            // console.log(res)
            setOtpModes(res.data.modes);
            setDisplayAuthMode(true);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const sendSelectedMode = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    if (Token()) {
      var post_data = {};
      post_data.query = {};

      post_data.query.id = getValues("abha_id");
      post_data.query.purpose = "KYC_AND_LINK";
      post_data.query.requester = {
        type: "HIP",
        id: "HLTHTEK_DEV",
      };
      post_data.query.authMode = data.selected_auth_mode;
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // console.log(res)
          if (res.data.status !== "") {
            // console.log(res)
            setTxnId(res.data.transaction_id);
            setDisplayOTP(true);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const confirmAuth = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    if (Token()) {
      var post_data = {};
      post_data.credential = {};
      var mode = getValues1("selected_auth_mode");

      post_data.transactionId = txnId;
      if (mode === "DEMOGRAPHICS") {
        post_data.credential.demographic = {};
        post_data.credential.demographic.name = getValues2("patient_name");
        post_data.credential.demographic.gender = getValues2("gender");
        post_data.credential.demographic.dateOfBirth = getValues2("dob");
        post_data.credential.demographic.authCode = "";
      } else {
        post_data.credential.authCode = getValues2("otp");
      }
      // console.log(post_data)
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}auth_confirm_workflow/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // console.log(res)
          if (res.data.status !== "") {
            // console.log(res)
            setTxnId(res.data.transaction_id);
            setAccessToken(res.data.access_token);
            setDisplayAddCareContext(true);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const AddCareContext = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    if (Token()) {
      var post_data = {};
      post_data.link = {};
      post_data.link.accessToken = accessToken;
      post_data.link.patient = {};
      post_data.link.patient.referenceNumber = getValues3("patient_id");
      post_data.link.patient.display = getValues("abha_id");
      post_data.link.patient.careContexts = [];
      var careContextData = {};
      careContextData.referenceNumber = "visit-" + Math.random();
      careContextData.display = getValues3("visit_details");
      post_data.link.patient.careContexts[0] = careContextData;

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}add_context_workflow/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // console.log(res)
          if (res.data.status !== "Failed") {
            // console.log(res)
            setReferenceNumber(careContextData.referenceNumber);
            PatientNotificationCareContext("test");
            toast.error(res.data.acknowledgement_status);
            // setDisplayNotificationCareContext(true)
          } else {
            toast.error(
              "Linking Token Failed. Please create a new one below !!"
            );
            setDisplayAddCareContext(false);
            setDisplayAuthMode(false);
            setDisplayOTP(false);
            setFindPatientModes(true);
            setDisplayNotificationCareContext(false);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const LinkingTokenLookup = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    if (Token()) {
      var post_data = {};
      post_data = {};

      post_data.id = getValues4("abha_id");
      if (!post_data.id.endsWith(REACT_APP_SUFFIX)) {
        post_data.id += REACT_APP_SUFFIX;
      }
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}patient_linking_token_lookup/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // console.log(res)
          if (res.data.status !== "No Linking Token available") {
            // console.log(res)
            setAccessToken(res.data.access_token);
            setDisplayAddCareContext(true);
            setDisplayAuthMode(false);
            setDisplayOTP(false);
            setFindPatientModes(false);
          } else {
            toast.error("No Linking Token Found. Please create one below !!");
            setDisplayAddCareContext(false);
            setDisplayAuthMode(false);
            setDisplayOTP(false);
            setFindPatientModes(true);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const PatientNotificationCareContext = (data, e) => {
    //ChangeCursor();
    if (Token()) {
      var post_data = {};
      post_data = {};

      post_data.patient = {};
      post_data.patient.id = getValues4("abha_id");

      post_data.careContext = {};
      post_data.careContext.patientReference = getValues3("patient_id");
      post_data.careContext.careContextReference = referenceNumber;

      // post_data.hiTypes = getValues5("hi_types")
      post_data.hiTypes = "OPConsultation";
      post_data.date = new Date();

      post_data.hip = {};
      post_data.hip.id = "HLTHTEK_DEV";

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}new_health_record_notification_for_existing_care_context_phr_endpoint/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // console.log(res)
          if (res.data.status !== "No Linking Token available") {
            // console.log(res)
            setAccessToken(res.data.access_token);
            setDisplayAddCareContext(true);
            setDisplayAuthMode(false);
            setDisplayOTP(false);
            setFindPatientModes(false);
            toast.error("Notification sent!!");
          } else {
            toast.error("No Linking Token Found. Please create one below !!");
            setDisplayAddCareContext(false);
            setDisplayAuthMode(false);
            setDisplayOTP(false);
            setFindPatientModes(true);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };
  return (
    <div>
      <h1 style={{ paddingLeft: "28%" }}>Linking Token Lookup</h1>
      <Container>
        <Row
          style={{
            marginTop: "2%",
            marginbottom: "2%",
            paddingBottom: "2%",
            width: "125%",
            marginLeft: "-10%",
          }}
        >
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="register_patient"
              style={{
                width: "100%",
                marginLeft: "-30%",
                height: "100%",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex" }} id="register_patient">
                <img
                  id="register_patient"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="register_patient"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  Register Patient
                </h6>
              </div>
            </Card>
          </Col>
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="care_context"
              style={{
                width: "140%",
                marginLeft: "-35%",
                height: "100%",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex" }} id="care_context">
                <img
                  src="/img/success-black-check-mark.svg"
                  id="care_context"
                  alt=""
                />
                <h6
                  id="care_context"
                  style={{ paddingTop: "8%", whiteSpace: "nowrap" }}
                >
                  Create & Link Visit Purpose
                </h6>
              </div>
            </Card>
          </Col>
          {sessionStorage.getItem("subscriptionType") !== undefined &&
          sessionStorage.getItem("subscriptionType") !== null &&
          sessionStorage
            .getItem("subscription_type")
            .includes("Connector/Adaptor") ? (
            []
          ) : (
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="upload_report"
                style={{ width: "100%", height: "100%", cursor: "pointer" }}
              >
                <div style={{ display: "flex" }} id="upload_report">
                  <img
                    id="upload_report"
                    src="/img/success-black-check-mark.svg"
                    alt=""
                  />
                  <h6
                    id="upload_report"
                    style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                  >
                    Upload Report
                  </h6>
                </div>
              </Card>
            </Col>
          )}
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="consent"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            >
              <div style={{ display: "flex" }} id="consent">
                <img
                  id="consent"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="consent"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  EHR Data Access
                </h6>
              </div>
            </Card>
          </Col>
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="admin_services"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            >
              <div style={{ display: "flex" }} id="admin_services">
                <img
                  id="admin_services"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="admin_services"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  Admin Services
                </h6>
              </div>
            </Card>
          </Col>
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="scan_qr"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            >
              <div style={{ display: "flex" }} id="scan_qr">
                <img
                  id="scan_qr"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="scan_qr"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  QR
                </h6>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <div
        className="col-sm-12 col-md-12 col-lg-7"
        style={{ marginLeft: "22%" }}
      >
        <div className="contact-panel mb-50">
          <form
            className="contact-panel__form"
            onSubmit={handleSubmit4(LinkingTokenLookup)}
          >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter ABHA Address"
                    name="abha_id"
                    {...register4("abha_id", {
                      required: "ABHA Address is required.",
                      minLength: {
                        value: 4,
                        message: "Minimum Length is 4.",
                      },
                      pattern: {
                        value: /^[a-zA-Z0-9](.*[a-zA-Z0-9]){2,}[a-zA-Z0-9]$/,
                        message:
                          "Alphanumeric characters only. Must be between 8 to 18 characters long. Special characters allowed: dot (.) or underscore (_), which cannot be in the beginning or at the end.",
                      },
                    })}
                  />
                  {errors4.abha_id && (
                    <p className="errorMsg">{errors4.abha_id.message}</p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Linking Token Lookup</span>{" "}
                  <i className="icon-arrow-right"></i>
                </button>
                <div className="contact-result"></div>
              </div>
            </div>
          </form>
          {findPatientModes ? (
            <form
              className="contact-panel__form"
              style={{ paddingTop: "3%" }}
              onSubmit={handleSubmit(FindPatientModes)}
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <i className="icon-news form-group-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ABHA Address"
                      name="abha_id"
                      {...register("abha_id", {
                        minLength: {
                          value: 4,
                          message: "Minimum Length is 4.",
                        },
                        pattern: {
                          value: /^[a-zA-Z0-9](.*[a-zA-Z0-9]){2,}[a-zA-Z0-9]$/,
                          message:
                            "Alphanumeric characters only. Must be between 8 to 18 characters long. Special characters allowed: dot (.) or underscore (_), which cannot be in the beginning or at the end.",
                        },
                      })}
                    />
                    {errors.abha_id && (
                      <p className="errorMsg">{errors.abha_id.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ABHA Number"
                      name="abha_number"
                      {...register("abha_number")}
                    />
                    {errors.abha_number && (
                      <p className="errorMsg">{errors.abha_number.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    <span>Find Modes</span> <i className="icon-arrow-right"></i>
                  </button>
                  <div className="contact-result"></div>
                </div>
              </div>
            </form>
          ) : (
            []
          )}

          {displayAuthMode ? (
            <form
              className="contact-panel__form"
              style={{ paddingTop: "3%" }}
              onSubmit={handleSubmit1(sendSelectedMode)}
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <i className="icon-user form-group-icon"></i>
                    <select
                      className="form-control"
                      name="selected_auth_mode"
                      {...register1("selected_auth_mode")}
                    >
                      {otpModes.map((item, index) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                    {errors1.selected_auth_mode && (
                      <p className="errorMsg">
                        {errors1.selected_auth_mode.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    <span>Get OTP</span> <i className="icon-arrow-right"></i>
                  </button>
                  <div className="contact-result"></div>
                </div>
              </div>
            </form>
          ) : (
            []
          )}
          {getValues1("selected_auth_mode") !== undefined &&
          getValues1("selected_auth_mode") !== null &&
          getValues1("selected_auth_mode").length > 0 &&
          getValues1("selected_auth_mode") !== "Choose Auth Mode" &&
          displayOTP ? (
            getValues1("selected_auth_mode") === "MOBILE_OTP" ? (
              <form
                className="contact-panel__form"
                style={{ paddingTop: "3%" }}
                onSubmit={handleSubmit2(confirmAuth)}
              >
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter OTP"
                        name="otp"
                        {...register2("otp", {
                          required: "OTP is required.",
                        })}
                      />
                      {errors2.otp && (
                        <p className="errorMsg">{errors2.otp.message}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                    >
                      <span>Confirm Authentication</span>{" "}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                </div>
              </form>
            ) : (
              <form
                className="contact-panel__form"
                style={{ paddingTop: "3%" }}
                onSubmit={handleSubmit2(confirmAuth)}
              >
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Patient Name"
                        name="patient_name"
                        {...register2("patient_name", {
                          required: "Patient Name is required.",
                        })}
                      />
                      {errors2.patient_name && (
                        <p className="errorMsg">
                          {errors2.patient_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-user form-group-icon"></i>
                      <select
                        className="form-control"
                        name="gender"
                        {...register2("gender")}
                      >
                        {gender.map((item, index) => (
                          <option value={item}>{item}</option>
                        ))}
                      </select>
                      {errors2.gender && (
                        <p className="errorMsg">{errors2.gender.message}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group form-group-date">
                      <i className="icon-calendar form-group-icon"></i>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Enter DOB"
                        name="dob"
                        {...register2("dob", {
                          required: "DOB is required.",
                        })}
                      />
                      {errors2.dob && (
                        <p className="errorMsg">{errors2.dob.message}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                    >
                      <span>Confirm Authentication</span>{" "}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                </div>
              </form>
            )
          ) : (
            []
          )}
          {displayAddCareContext ? (
            <form
              className="contact-panel__form"
              style={{ paddingTop: "3%" }}
              onSubmit={handleSubmit3(AddCareContext)}
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <i className="icon-news form-group-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Patient ID"
                      name="patient_id"
                      {...register3("patient_id", {
                        required: "Patient ID is required.",
                      })}
                    />
                    {errors3.patient_id && (
                      <p className="errorMsg">{errors3.patient_id.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Visit Purpose/Care Context"
                      name="visit_details"
                      {...register3("visit_details", {
                        required: "Visit Purpose/Care Context is required.",
                      })}
                    />
                    {errors3.visit_details && (
                      <p className="errorMsg">
                        {errors3.visit_details.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    <span>Add Visit Purpose</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                  <div className="contact-result"></div>
                </div>
              </div>
            </form>
          ) : (
            []
          )}
          {displayNotificationCareContext ? (
            <form
              className="contact-panel__form"
              style={{ paddingTop: "3%" }}
              onSubmit={handleSubmit5(PatientNotificationCareContext)}
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <i className="icon-news form-group-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Patient ID"
                      name="patient_id"
                      {...register5("patient_id", {
                        required: "Patient ID is required.",
                      })}
                    />
                    {errors5.patient_id && (
                      <p className="errorMsg">{errors5.patient_id.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ABHA Number"
                      name="visit_details"
                      {...register5("visit_details", {
                        required: "Visit Details is required.",
                      })}
                    />
                    {errors5.visit_details && (
                      <p className="errorMsg">
                        {errors5.visit_details.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    <span>Add Visit Purpose</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                  <div className="contact-result"></div>
                </div>
              </div>
            </form>
          ) : (
            []
          )}
        </div>
      </div>
    </div>
  );
}

export default ExchangePatientEMR;
